import { AxiosPromise } from 'axios';
import { IrClaimTechnology } from '../store/irClaimSlice';
import api from './api';

export default function updateClaimTechnology(
  id: number, updateBody: Partial<IrClaimTechnology>,
) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .patch(`ir-claim-technology/${id}`, updateBody)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
